import { Adapter as r } from "../../../../adapter.js";
import { ShopSessionLandingModel as t } from "./landing.model.js";
class d extends r {
  adapt(e) {
    return new t({
      queryString: e.querystring,
      queryStringDict: e.querystring_dict
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  d as ShopSessionLandingAdapter
};
//# sourceMappingURL=landing.adapter.js.map
